import * as types from '../constants/ScheduleActionTypes';
import fetch from 'isomorphic-fetch'
import {env} from '../constants/Environment';

const moment = require('moment')

const colorsForEventtype = {
    'tdw': {
        backgroundColor: '#a477c4',
        color: '#FFFFFF'
    },
    'powerplay': {
        backgroundColor: '#3498db',
        color: '#FFFFFF'
    },
    '1-0-2': {
        backgroundColor: '#1abc9c',
        color: '#000000'
    }
};

export function fetch_schedule(firestore, scheduleId, start, end) {
	return function(dispatch){
		dispatch(request_schedule(scheduleId));
		
        return (new Promise((resolve, reject) => {				
				(async () => {
					let doc = firestore.collection('environments/' + env + '/channels/displays/lotteries/11/schedules').doc(moment.unix(start).format('YYYY-MM-DD'));

                    var snapshot = null;
                    try {
                        snapshot = await doc.get();
                    }catch(e){
                        console.log('Schedules', e);
                    }
                    let data = snapshot.data();

                    var transformed = [];
                    for(var type in data){
                        let slots = data[type];

                        for(var slotIdx in slots){
                            for(var idx in slots[slotIdx]){
                                let item = slots[slotIdx][idx];

                                //Load Event-Metadata
                                let eventDoc = await firestore.collection('environments/' + env + '/programs/0/oe/').doc(item.id).get();
                                if(!eventDoc.exists)continue;

                                let event = eventDoc.data();

                                if(typeof transformed[slotIdx] === 'undefined')
                                    transformed[slotIdx] = {
                                        items: []
                                    };
                                
                                transformed.push({
                                    meta: {
                                        id: item.id,
                                        type: type,
                                        name: event.name,
                                        color: colorsForEventtype[type].color,
                                        backgroundColor: colorsForEventtype[type].backgroundColor
                                    },
                                    start: item['active-from'].seconds,
                                    end: item['active-to'].seconds,
                                    priority: slotIdx
                                });
                            }
                        }
                    }

                    transformed = Object.values(_.reject(transformed, (t) => (typeof t === 'undefined' || t.length === 0)));

                    dispatch(receive_schedule(scheduleId, transformed));

					resolve();
				})();
			}));
	}
}

export function request_schedule(scheduleId) {  
  return {
    type: types.REQUEST_SCHEDULE,
    scheduleId: scheduleId
  };
}

export function receive_schedule(scheduleId, data){
	return  {
		type: types.RECEIVE_SCHEDULE,
		schedule: data,
		scheduleId: scheduleId
	}
}